<template>
  <div :class="appBackgroundClass" id="salary-app" ref="salaryApp">
    <div v-if="!isDataFetched">
      <LoadingDots :isWhite="!isAuth" />
    </div>

    <transition name="fade">
      <div v-if="isDataFetched" class="container">
        <FormState :recalc="recalc" @update:recalc="recalc = $event"></FormState>
        <IntroPage v-if="!started"></IntroPage>
        <div v-if="started" class="question-pages">
          <QuestionPage v-if="!isLastPage" />
          <ResultPage v-if="isLastPage"></ResultPage>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import LoadingDots from '@/components/loading/LoadingDots.vue'
import QuestionPage from './components/QuestionPage.vue'
import FormState from './components/FormState.vue'
import ResultPage from './components/ResultPage.vue'
import { state, getCalculatedSalaryEstimatePayload } from '@/lib/state'
import IntroPage from './components/IntroPage.vue'
import { isDesktop } from '@/util/screenUtil'
import { getCalculatedSalaryEstimate } from '@/services/user-data-service'
import { isAuthenticated } from '../../../services/service-api-member.js'
import { getAuthenticatedMemberId, getMasterDataForMember } from '@/services/user-data-service.js'
export default {
  components: {
    QuestionPage,
    FormState,
    ResultPage,
    IntroPage,
    LoadingDots,
  },
  props: {
    isAuth: {
      type: Boolean,
      required: true,
    },
  },
  data: function () {
    return {
      state: state,
      currentPage: state.currentPage,
      started: false,
      recalc: false,
      isAlreadyAuthenticated: false,
      colorDarkBlue:
        getComputedStyle(document.documentElement)?.getPropertyValue('--color-darkblue')?.trim() ||
        '',
      colorWhite:
        getComputedStyle(document.documentElement)?.getPropertyValue('--color-white')?.trim() || '',
    }
  },
  computed: {
    isLastPage() {
      return this.currentPage === -1
    },
    isDataFetched() {
      return state.isDataFetched
    },
    appBackgroundClass() {
      if (!this.started) {
        return 'background-white background-first-page'
      } else if (this.isLastPage) {
        return 'background-white background-last-page'
      } else {
        return 'background-blue'
      }
    },
    breadcrumb() {
      return document.querySelector('.breadcrumb') || null
    },
    logo() {
      return document.querySelector('.menu-logo-text .logo-text') || null
    },
  },

  async mounted() {
    // We'll let main.js handle the initial segmentation event dispatch
    // based on URL parameters or authentication status

    try {
      const userAuthenticated = await isAuthenticated()

      if (userAuthenticated) {
        const memberId = await getAuthenticatedMemberId()
        // Extract memberId from object if needed (handles both string and {memberId: "..."} formats)
        this.state.user.memberId = typeof memberId === 'object' && memberId?.memberId ? memberId.memberId : memberId
        console.log('Authenticated member ID:', this.state.user.memberId)

        const memberData = await getMasterDataForMember(this.state.culture)
        // Add firstName to user state
        if (memberData.firstname) {
          this.state.user.firstName = memberData.firstname
        }

        // Add email to user state
        if (memberData.privateEmail) {
          this.state.user.privateEmail = memberData.privateEmail
        }

        if (memberData.workEmail) {
          this.state.user.workEmail = memberData.workEmail
        }

        Object.keys(memberData).forEach((key) => {
          console.log('KEY KEY KEY =>>>', key)
          const stateKey = Object.keys(state.listKeys).find(
            (stateKey) => state.listKeys[stateKey].toLowerCase() === key.toLowerCase(),
          )

          if (stateKey && memberData[key]) {
            if (stateKey === 'Salary.Questions.YourAge') {
              // Age has special handling where we use name property directly
              state.user.memberData[stateKey] = memberData[key].name
            } else if (stateKey === 'Salary.Questions.WorkArea') {
              console.log('HAXING', memberData)
              if (Array.isArray(memberData.workareas) && memberData.workareas.length > 0) {
                state.user.memberData['Salary.Questions.WorkArea'] =
                  memberData.workareas[0].categoryKey
                state.user.memberData['Salary.Questions.WorkFunction'] =
                  memberData.workareas[0].subCategoryKey
              }
              console.log('MAP MAP MAP WORK AREAS HERE ', memberData[key])
            } else {
              // Standard fields with id and name/text
              state.user.memberData[stateKey] = memberData[key].id
            }
          }
        })

        this.state.userAuthenticated = true
        this.state.user.isMember = true

        this.unHideBreadcrumbs()
        this.startQuestions()
      }
    } catch (error) {
      console.error('Authentication error:', error)
    } finally {

      this.isAuthenticating = false
    }
    this.emitter.on('page-change', () => {
      this.currentPage = state.currentPage
    })
    this.emitter.on('submit', () => {
      this.handleSubmit()
    })
    this.emitter.on('start-questions', () => {
      this.startQuestions()
    })
    this.emitter.on('recalc-questions', () => {
      this.recalc = true
    })
  },
  methods: {
    loadStore() {
      this.emitter.emit(`start-questions`)
      this.emitter.emit('submit')
      state.currentPage = -1
      this.emitter.emit('page-change')
    },
    startQuestions() {
      this.started = true

      // hide header when starting questions
      const header = document.querySelector('[data-component="salary-app-header"]')
      if (header) {
        header.style.display = 'none'
      }

      if (this.breadcrumb) {
        this.setBreadcrumbStyling()
      }

      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    },
    unHideBreadcrumbs() {
      const topNavigation = document.querySelector('#top-nav-container')
      if (!topNavigation) return

      topNavigation.style.display = 'block'
    },
    async handleSubmit() {
      state.isSubmitting = true
      console.log('SUBMITTING INSIDE handleSubmit function on App.Vue', state)

      // post data to API
      const payload = getCalculatedSalaryEstimatePayload()

      try {
        const data = await getCalculatedSalaryEstimate(payload)
        state.resultData = data
        console.log('Data submitted successfully:', data)
        this.currentPage = -1
        this.resetBreadcrumbStyling()
      } catch (error) {
        // TODO: show error message to user
        console.error('Error submitting data:', error)
      } finally {
        state.isSubmitting = false
      }
    },
    setBreadcrumbStyling() {
      // Make sure the breadcrumb element exists and has loaded
      const breadcrumb = document.querySelector('.breadcrumb')
      const logo = document.querySelector('.menu-logo-text .logo-text')

      if (isDesktop() && breadcrumb && breadcrumb.style) {
        // move app up to remove breadcrumb blank space
        const breadcrumbHeight = breadcrumb.offsetHeight
        if (this.$refs.salaryApp) {
          this.$refs.salaryApp.style.marginTop = `-${breadcrumbHeight}px`
        }

        breadcrumb.style.color = this.colorWhite
        if (logo && logo.style) {
          logo.style.color = this.colorWhite
        }
      }
    },
    resetBreadcrumbStyling() {
      // Make sure the breadcrumb element exists and has loaded
      const breadcrumb = document.querySelector('.breadcrumb')
      const logo = document.querySelector('.menu-logo-text .logo-text')

      if (isDesktop() && breadcrumb && breadcrumb.style) {
        // reset app margin
        if (this.$refs.salaryApp) {
          this.$refs.salaryApp.style.marginTop = '0'
        }

        // set color back to blue
        breadcrumb.style.color = this.colorDarkBlue
        if (logo && logo.style) {
          logo.style.color = this.colorDarkBlue
        }
      }
    },
  },
}
</script>

<style lang="postcss" scoped>
.dev {
  width: max-content;
  position: relative;
  display: flex;
  left: 50%;
  bottom: 0;
  transform: translateX(-50%);
  color: var(--color-black);
  padding: 8px;
  margin-top: 48px;
  gap: 8px;

  button {
    background-color: var(--color-yellow);
    padding: 4px;
  }
}

#salary-app {
  min-height: 400px;
  --color-blue: #005bf5;
  width: 100%;
  overflow-x: hidden;
  position: relative;
}

.question-pages {
  display: flex;
  flex-direction: column;
  gap: 28px;
  height: 100%;
  padding: 18px 0;
}

.container {
  height: 100%;
}

@media (min-width: 1024px) {
  #salary-app {
    padding-top: 124px;
    transition: background-color var(--ani-speed-4);
  }

  .loading-container {
    position: relative;
    min-height: 400px;
    color: var(--color-darkblue);
  }

  #salary-app.background-first-page {
    height: 100%;
    padding-top: 0;
    padding-bottom: var(--grid-gutter-3);
  }

  #salary-app.background-last-page {
    height: 100%;
    padding-top: 124px;
    padding-bottom: var(--grid-gutter-3);
  }

  .background-white {
    height: 100dvh;
    background-color: var(--color-white);
  }

  .background-blue {
    height: 100dvh;
    background-color: var(--color-blue);
  }
}

.fade-enter-active {
  transition: opacity 0.2s ease-in-out;
}

.fade-enter-from {
  opacity: 0;
}

.fade-enter-to {
  opacity: 1;
}

:deep(a) {
  color: var(--color-blue);
  position: relative;
  overflow: hidden;
  padding-bottom: 2px;

  &::after {
    content: '';
    position: absolute;
    bottom: 1px;
    left: 0;
    right: 0;
    border-bottom: solid 2px currentColor;
    transform: translateX(-101%);
    transition: all var(--ani-speed-3) var(--ani-type-1);
    width: 100%;
    display: block;
  }
}

:deep(a):hover {
  &::after {
    transform: translateX(0);
  }
}
</style>
